<template>
  <div class="plhksqApply">
    <Header title="缓考申请"></Header>
    <div class="apply-body">
      <div
        class="body-content border"
        v-for="(item, index) in list"
        :key="index"
      >
        <div>
          <p v-if="!flag" :class="returnClass(item.shzt)">
            {{ item.shzt }}
          </p>
          <p class="apply-title">{{ item.courseName }}</p>
          <van-row>
            <van-col span="12">
              <p class="apply-num">课程号：{{ item.kch }}</p>
              <p class="apply-num">考试方式：{{ item.ksfs }}</p>
            </van-col>
            <van-col span="12">
              <p class="apply-num">学时：{{ item.period }}</p>
              <p class="apply-num">学分：{{ item.credit }}</p>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="apply-inputs">
        <div v-if="flag" class="apply-input">
          <p>申请原因</p>
          <input type="text" placeholder="请点击填写" v-model="reason" />
        </div>
        <div v-if="flag" class="apply-input">
          <p>上传附件</p>
          <van-uploader
            v-model="fileList"
            :after-read="afterRead"
            :max-size="10 * 1024 * 1024"
            @oversize="onOversize"
            :max-count="1"
          />
        </div>
        <div class="apply-input">
          <p>审核人</p>
          <input
            type="text"
            placeholder="请点击选择"
            @click="showShr"
            v-model="shr.mc"
            readonly
          />
          <i class="arrow"></i>
        </div>
      </div>
    </div>
    <div class="apply-btn">
      <p v-if="flag" class="tishi">ps:暂存时审核人选择无效，请勿选！</p>
      <p v-else class="tishi">ps:暂存后申请原因和附件都不可以更改！</p>
      <button v-if="flag" @click="submitApply(0)">暂存</button>
      <button v-else @click="back()">撤销</button>
      <button @click="submitApply(1)">提交申请</button>
    </div>

    <van-popup v-model="show" position="bottom" @close="close">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="close"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            v-for="(item, index) in shrList"
            @click="personTap($event, index)"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      flag: true,
      reason: "",
      fileList: [],
      file: {},
      isShow: false,
      list: [],
      show: false,
      shr: {},
      shrList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ]
    };
  },
  created() {
    if (!!this.$route.query.flag) {
      this.flag = false;
    }
    if (this.flag) {
      this.list = JSON.parse(this.$route.query.data);
    } else {
      this.list = JSON.parse(this.$route.query.list).kcdata;
    }
    this.getShr();
  },
  methods: {
    returnClass(shzt) {
      switch (shzt) {
        case "不通过":
          return "apply-ttl btgClass";
        case "待审核":
          return "apply-ttl dssClass";
        case "审核中":
          return "apply-ttl shzClass";
        case "取消审核":
          return "apply-ttl qxshClass";
        default:
          return "apply-ttl ytgClass";
      }
    },
    async back() {
      const res = await Api.hksq_cancel({
        cj0704hkid: JSON.parse(this.$route.query.list).cj0704hkid
      });

      if (res.code == "1") {
        this.$toast.success(res.Msg);
        setTimeout(() => {
          this.$router.replace("/plhksq/myApply");
        }, 1500);
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      this.file = file.file;
    },
    onOversize() {
      this.$toast.fail("文件大小不能超过10M");
    },
    async submitApply(flag) {
      let params = {
        //   0 暂存，1 送审
        type: flag.toString()
      };
      // 点击提交申请按钮
      if (flag == 1 && JSON.stringify(this.shr) == "{}") {
        this.$toast.fail("请选择审核人~");
        return;
      }
      params.auditor = this.shr.mc == "全部" ? "" : this.shr.dm;

      // 未暂存的申请数据
      if (this.flag) {
        if (this.flag && this.fileList.length <= 0) {
          this.$toast.fail("请上传附件~");
          return;
        } else if (this.flag && this.reason == "") {
          this.$toast.fail("请填写申请原因~");
          return;
        }
        let idarr = [];
        this.list.forEach(item => {
          idarr.push(item.cj0704id);
        });

        params.cj0704id = idarr.join(",");
        params.hksqfj = this.file;
        params.reason = this.reason;
      } else {
        //  暂存的申请数据
        params.cj0704hkid = JSON.parse(this.$route.query.list).cj0704hkid;
      }

      const res = await Api.slowExaminationSave(params);

      if (res.code == "1") {
        this.$toast.success(res.Msg);
        setTimeout(() => {
          this.$router.replace("/plhksq/index");
        }, 1500);
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    // 获取审核人列表
    async getShr() {
      let concatList2 = [];
      let concatList3 = [];
      const params = {
        ywcode: "019",
        ywid: ""
      };
      const res = await Api.selectReviewerApi(params);
      res.data.forEach((item, index) => {
        concatList2[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.shrList = this.shrList.concat(concatList2);
    },
    close() {
      this.show = false;
    },
    showShr() {
      this.show = true;
    },
    // 审核人选择完后点击确认
    resetCancel() {
      this.show = false;
      this.shr.mc = this.reset;
      this.shr.dm = this.resetId;
    },
    // 审核人弹框中的按钮选择
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.shrList[res].isBtn == 0) {
        this.shrList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.shrList[res].isBtn == 1) {
        this.shrList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.shrList) {
        if (this.shrList[res].name == "全部") {
          this.shrList[i].isBtn = 0;
          this.shrList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.shrList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.shrList[i].isBtn == 1) {
          strList = strList.concat(this.shrList[i].name);
          idList = idList.concat(this.shrList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    }
  }
};
</script>

<style lang="less" scoped>
.plhksqApply {
  .apply-body {
    padding: 20px;
    height: 78vh;
    overflow: auto;
    .border {
      position: relative;
      padding: 10px;
      background: #f5f5f5;
      border: 1px solid #ecedfd;
      border-radius: 8px;
      margin-bottom: 20px;
      .apply-input {
        border-bottom: 1px solid #e5e5e5;
      }
    }
  }
  .apply-body .apply-title {
    font-size: 18px;
    color: @attendance-color-1;
    font-weight: 600;
  }
  .apply-body .apply-num {
    font-size: 14px;
    color: @attendance-color-2;
    margin-top: 8px;
  }
  .apply-inputs {
    margin-top: 17px;
  }
  .apply-inputs .apply-input {
    padding: 9px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid @attendance-border-color-6;
    color: @attendance-color-1;
  }
  .apply-input input {
    flex: 1;
    text-align: right;
    color: @attendance-color-1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 20px;
  }
  .apply-input input::placeholder {
    color: @attendance-background-color-2;
    font-size: 16px;
  }
  .apply-btn {
    position: fixed;
    padding: 30px 20px 20px;
    width: 100%;
    text-align: center;
    display: flex;
    bottom: 0;
    background-color: @attendance-color-3;
    box-sizing: border-box;
  }
  .apply-btn .tishi {
    position: absolute;
    top: 0;
    width: 100%;
    text-align: center;
    color: red;
  }
  .apply-btn button {
    flex: 1;
    background-color: @attendance-background-color-1;
    color: @attendance-color-3;
    padding: 11px 0;
    border-radius: 3px;
  }
  .apply-btn button + button {
    margin-left: 10px;
    background-color: @attendance-background-color-7;
    color: @attendance-background-color-1;
  }
  .apply-pop {
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color: @attendance-color-3;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    max-height: 40%;
    overflow-y: scroll;
  }
  .close-icon {
    background: url(../../../../../static/img/close.png) no-repeat center;
  }
  .pop-title {
    display: flex;
    justify-content: space-between;
    padding: 13px;
    position: fixed;
    width: 100%;
    background-color: @attendance-color-3;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    z-index: 9;
  }
  .pop-title i {
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
  }
  .confirm-icon {
    background: url(../../../../../static/img/confirm.png) no-repeat center;
  }
  .apply-pop .person {
    padding: 20px 20px 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: 48px;
  }
  .person button {
    border-radius: 3px;
    padding: 5px 15px;
    margin-right: 12px;
    margin-bottom: 15px;
  }
  .apply-pop .person .per-btn {
    background-color: @attendance-background-color-7;
    color: @attendance-background-color-1;
  }
  .person .cur {
    background-color: @attendance-background-color-1;
    color: @attendance-background-color-7;
  }
  .apply-input .arrow {
    background: url(../../../../../static/img/arrow_r.png) no-repeat center;
    width: 13px;
    height: 13px;
    background-size: 13px 13px;
    margin-left: 10px;
  }
  .apply-ttl {
    position: absolute;
    right: 20px;
    top: 40px;
    font-size: 20px;
    font-weight: 700;
  }
  .shzClass {
    color: #7469f8 !important;
  }
  .btgClass {
    color: #f86969 !important;
  }
  .ytgClass {
    color: #12ddd6 !important;
  }
  .dssClass {
    color: #757da3 !important;
  }
  .qxshClass {
    color: #000 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/plhksq/apply.vue